export enum FishingRadioProvider {
  LofiCafe = 'lofi-cafe',
  Radio101 = 'radio-101',
}

export const RADIO_101_LOFI_STREAM_URL = 'https://srv01.gpmradio.ru:443/stream/pro/aac/64/358'

// 22.05 kHz mono AAC+ is the only format the station publishes; browsers without an
// HE-AAC decoder report it through the media element's error event.
export const RADIO_101_LOFI_STREAM_MIME = 'audio/aac'

export const RADIO_101_CHANNEL_URL = 'https://101.ru/radio/channel/358'

export const RADIO_101_UNSUPPORTED_MESSAGE = 'Браузер не воспроизводит этот поток'
export const RADIO_101_UNSUPPORTED_HINT = 'Откройте Chrome или Яндекс Браузер'
export const RADIO_101_UNSUPPORTED_LINK_LABEL = 'Слушать на 101.ru'

export function fishingRadioProviderForCountry(countryCode: string | null) {
  return countryCode?.trim().toUpperCase() === 'RU'
    ? FishingRadioProvider.Radio101
    : FishingRadioProvider.LofiCafe
}
